/**
 * 값이 빠진 빌드(qa·staging·master·새 브랜치)에서 숨겨지도록 기본은 끔이다.
 * .env.development 는 dev 서버에서만 읽히므로 develop 빌드는 amplify.yml 에서 켠다.
 * 호출 시점에 읽는 이유: 시험에서 vi.stubEnv 로 값을 바꿀 수 있어야 한다.
 */
export const isClinicalAssessmentEnabled = () => import.meta.env.VITE_ENABLE_CLINICAL_ASSESSMENT === 'true';
